module.exports = __webpack_public_path__ + "static/media/figure16.3720e49b.png";